export const JIRA_DESCRIPTION_PLATFORM = {
	WEB: 'web',
	MOBILE: 'mobile'
} as const;

export type JiraDescriptionPlatform =
	(typeof JIRA_DESCRIPTION_PLATFORM)[keyof typeof JIRA_DESCRIPTION_PLATFORM];
